import { useTranslation } from 'react-i18next';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './InfoModalWrapper.module.css';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  onClose?: (() => void) | undefined;
}

export const InfoModalWrapper = ({ children, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>INFO</div>
      {children}
      <div className={styles.buttonsWrapper}>
        <button onClick={onClose}>
          <ThemeIcon icon="chevron-right" alt="Info" variant="inline" />
          {t('close_label')}
        </button>
      </div>
    </div>
  );
};
